/** The step-validation pair a create form exposes to the drawer. */
export interface StepNavForm {
  /** Writes the step's inline errors and reports whether it is valid. */
  validateStep: (step?: number) => boolean;
  /** True when every step before `target` is valid. */
  stepReachable: (target: number) => boolean;
}

/** Backward is free; a forward move validates the current step inline and
 *  blocks on failure; a forward jump past the next step also needs every
 *  intervening step valid. */
export function makeNavGuard(form: StepNavForm) {
  return (target: number, current: number): boolean => {
    if (target <= current) return true;
    if (!form.validateStep(current)) return false;
    return !(target > current + 1) || form.stepReachable(target);
  };
}
